import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Client } from '../../client/classes/client';
import { MeineKontakteDialogInput, MeineKontakteDialogResult } from './meine-kontakte-dialog';

@Component({
    selector: 'kiene-meine-kontakte-dialog',
    templateUrl: './meine-kontakte-dialog.component.html',
    styleUrls: ['./meine-kontakte-dialog.component.scss'],
})
export class MeineKontakteDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<MeineKontakteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public input: MeineKontakteDialogInput,
    ) {}

    ngOnInit(): void {}

    close() {
        this.dialogRef.close();
    }

    setContact(client: Client) {
        const result = new MeineKontakteDialogResult(client);
        this.dialogRef.close(result);
    }
}
